import React from 'react'

export default () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M5.95952 3.29289C6.35004 2.90237 6.98321 2.90237 7.37373 3.29289L11.3737 7.29289C11.7643 7.68342 11.7643 8.31658 11.3737 8.70711L7.37373 12.7071C6.98321 13.0976 6.35004 13.0976 5.95952 12.7071C5.56899 12.3166 5.56899 11.6834 5.95952 11.2929L9.25241 8L5.95952 4.70711C5.56899 4.31658 5.56899 3.68342 5.95952 3.29289Z" fill="#194074"/>
  </svg>

)
